import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { Component, OnInit, Input } from '@angular/core';
import { GenericResponse } from 'src/app/data/repository/generic-response';

@Component({
  selector: 'app-edit-bio',
  templateUrl: './edit-bio.component.html',
  styleUrls: ['./edit-bio.component.scss'],
})
export class EditBioComponent implements OnInit {
  @Input() bio: string;

  isIOS = false;

  constructor(private blogService: BlogService) {
    this.isIOS = this.isIos();
  }

  ngOnInit() {
    setTimeout(() => {
      if (!this.isIOS) {
        document.getElementById('textarea').focus();
      }
      this.autoGrow();
    }, 100);
  }

  save(): Promise<GenericResponse> {
    // console.log('saved', this.bio);
    return this.blogService.editBlogUser(null, null, this.bio, null, null);
  }

  autoGrow() {
    document.getElementById('textarea').style.height = '5px';
    document.getElementById('textarea').style.height =
      document.getElementById('textarea').scrollHeight - 4 + 'px';
    document.getElementById('bioHolder').style.height =
      (document.getElementById('textarea').scrollHeight + 9).toString() + 'px';
  }

  isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };
}
